import { isPendingClientSubmission } from './applicationClientVisibility';

/** Number of configured interview rounds on this application. */
export function interviewRoundCount(app) {
  return (app.interviewRounds || app.jobInterviewRounds || []).length;
}

/** 1-based index of the active interview round. */
export function currentInterviewRoundNumber(app) {
  const rounds = app.interviewRounds || [];
  if (!rounds.length) return null;
  const idx = rounds.findIndex(r => r.roundId === app.currentInterviewRoundId);
  if (idx >= 0) return idx + 1;
  const pendingIdx = rounds.findIndex(r => r.status !== 'completed');
  return pendingIdx >= 0 ? pendingIdx + 1 : rounds.length;
}

/** ATS stage column label — Interview 1, Interview 2, … when job has multiple rounds. */
export function appStageDisplayLabel(app, stageLabels = {}) {
  if (isPendingClientSubmission(app)) {
    return 'Internal review';
  }
  if (app.stage !== 'interview') {
    return stageLabels[app.stage] || app.stage || '—';
  }
  const total = interviewRoundCount(app);
  const num = currentInterviewRoundNumber(app);
  if (total > 1 && num) return `Interview ${num}`;
  if (app.currentInterviewRoundName) return app.currentInterviewRoundName;
  return stageLabels.interview || 'Interview';
}

/** Label for a round at index (Interview 1, Interview 2, … when job has multiple rounds). */
export function interviewRoundLabelAt(app, idx) {
  const rounds = app.interviewRounds || [];
  const total = interviewRoundCount(app);
  if (total > 1) return `Interview ${idx + 1}`;
  return rounds[idx]?.name || `Interview ${idx + 1}`;
}

/** Short label for the active round (Interview 1, Interview 2, …). */
export function activeInterviewRoundLabel(app) {
  const total = interviewRoundCount(app);
  const num = currentInterviewRoundNumber(app);
  if (total > 1 && num) return `Interview ${num}`;
  return app.currentInterviewRoundName || 'Interview';
}
